import { useRef } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

type Params = {
    play: () => void;
    pause: () => void;
};

export const useActiveTabController = ({ play, pause }: Params) => {
    const isPlayingBeforeTabChanged = useRef<boolean | null>(null);

    useInstanceEffect(
        (instance) => {
            const handleVisibilityChange = () => {
                if (document.hidden && instance?.isMuted) {
                    isPlayingBeforeTabChanged.current = instance.playingState === PlayingState.play;
                    pause();

                    return;
                }

                if (isPlayingBeforeTabChanged.current) {
                    isPlayingBeforeTabChanged.current = null;
                    play();
                }
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);

            return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
        },
        [play, pause]
    );
};
